import Url from 'url-parse';
import LinkIcon from '@material-ui/icons/Link';
import React, { FC } from 'react';
import 'twin.macro';

type Props = {
  title?: string;
  url: string;
};
const ContentSource: FC<Props> = ({ title, url, ...props }) => {
  if (!url) {
    return <></>;
  }
  const urlParsed = new Url(url);
  return (
    <a
      tw="flex items-center space-x-2 "
      rel="noreferrer"
      href={url}
      target="_blank"
      {...props}
    >
      <LinkIcon />
      <div>
        <p>{title || urlParsed.host}</p>
      </div>
    </a>
  );
};

export default ContentSource;
